import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { useApiDefaults } from './useApiDefaults';
import { getStoreDetails } from 'redux/actions';

export default function useShippingLabel() {
  const { storeDetails } = useSelector(({ store }) => store);
  const dispatch = useDispatch()

  const shippingLabelLower = storeDetails?.delivery_method_lable?.toLowerCase() || "delivery"
  const shippingLabelTitle = shippingLabelLower.charAt(0).toUpperCase() + shippingLabelLower.slice(1)

  const apiDefaults = useApiDefaults()

  useEffect(() => {
    if (!storeDetails) {
      dispatch(getStoreDetails(apiDefaults));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, storeDetails])

  return {
    shippingLabelLower,
    shippingLabelTitle
  }
}